import { Component, Inject, OnInit } from '@angular/core';
import { ClientService } from '../../../../_services';
import { ToastrService } from 'ngx-toastr';
import { ClientSearch } from '../../../../_models/customers/client/ClientSearch';
import { ClientRequest } from '../../../../_models/customers/client/ClientRequest';
import { EditExternalUserComponent } from '../edit-external-user/edit-external-user.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import {ColDef, ColGroupDef, ColumnApi, GridApi, GridOptions, IDatasource, IGetRowsParams, SortModelItem } from 'ag-grid-community';
import { ButtonCustomerRendererComponent } from './buttoncustomer-renderer.component';
import { ImageCustomerFormatterComponent } from './image-cutomerformatter.component';
import { aggridLocaleFr } from '../../../../../assets/aggrid-locale.fr.js';
import { LocalStorageKey } from "../../../../_models/constants/local-storage";
import { TranslateService } from '@ngx-translate/core';


import { CustomerResponse } from "../../../../_models/planification/CustomerResponse";
import { ClientAutorisationStatusValues } from "../../../../_models/customers/client/ClientAutorisationStatus";

@Component({
   selector: 'app-list-customers',
   templateUrl: './list-customers.component.html',
   styleUrls: ['./list-customers.component.scss']
})
export class ListCustomersComponent implements OnInit {
   autorisation: ClientAutorisationStatusValues;
   clientRequest: ClientRequest;
   gridColumnApi: ColumnApi;
   frameworkComponents: any;
   rowData: CustomerResponse[];
   gridOptions: GridOptions<CustomerResponse>;
   gridApi: GridApi<CustomerResponse>;
   columnDefs: (ColDef<CustomerResponse> | ColGroupDef<CustomerResponse>)[];
   defaultColDef: ColDef<CustomerResponse>;
   components: any;
   jwtToken: string;

   constructor(
      private listCustomerService: ClientService,
      public dialog: MatDialog,
      private translate: TranslateService
   ) {
      this.frameworkComponents = {
         buttonRenderer: ButtonCustomerRendererComponent,
         imageCustomerFormatterComponent: ImageCustomerFormatterComponent,
      };
      /**
       private String customerId;

       private String name;

       private String siren;

       private String siret;

       private String customerType;

       private String commercial;

       private Date creationDate;

       private  byte[] logo;

       private String logoName;

       private String autorisationStatus;

       private String autorisationLevel;
       */
      this.columnDefs = [
         {
            headerName: 'Siren',
            colId: 'siren',
            field: 'siren',
            cellRenderer: 'loadingRenderer',
            sortable: true,
            filter: 'agTextColumnFilter',
            resizable: true,
            suppressMenu: true,
            filterParams: {
               buttons: ['reset', 'apply'],
               filterOptions: ['contains'],
               closeOnApply: true,
               suppressAndOrCondition: true,
            }
         },

         {
            headerName: this.translate.instant('ADVERTISER_NAME'),
            colId: 'name',
            field: 'logo',
            cellRenderer: ImageCustomerFormatterComponent,
            cellRendererParams: {
               color: function (field: any) {
                  if (field.data) {
                     return field.data.name;
                  }
               }
            },
            sortable: true,
            filter: 'agTextColumnFilter',
            resizable: true,
            suppressMenu: true,
            filterParams: {
               buttons: ['reset', 'apply'],
               filterOptions: ['contains'],
               closeOnApply: true,
               suppressAndOrCondition: true,
            }
         },

         {
            headerName: 'Type',
            colId: 'customerType',
            field: 'customerType',
            resizable: true,
            sortable: true,
            suppressMenu: true,
            filter: 'agTextColumnFilter',
            maxWidth: 120,
            filterParams: {
               buttons: ['reset', 'apply'],
               filterOptions: ['contains'],
               closeOnApply: true,
               suppressAndOrCondition: true,
            }
         },

         {
            headerName: this.translate.instant('COMMERCIAL'),
            colId: 'commercial',
            field: 'commercial',
            sortable: false,
            suppressMenu: true,
            resizable: true,
            filter: 'agTextColumnFilter',
            filterParams: {
               buttons: ['reset', 'apply'],
               filterOptions: ['contains'],
               closeOnApply: true,
               suppressAndOrCondition: true,
            }
         },

         {
            headerName: this.translate.instant('CREATION_DATE'),
            colId: 'creationDate',
            field: 'creationDate',
            sortable: true,
            sort: 'desc',
            filter: 'agDateColumnFilter',
            resizable: true,
            suppressMenu: true,
            filterParams: {
               buttons: ['reset', 'apply'],
               closeOnApply: true,
               suppressAndOrCondition: true,
               filterOptions: ['equals', 'lessThan', 'greaterThanOrEqual'],
               floatingFilterComponentParams: {
                  suppressFilterButton: true,
               },
            }
         },

         {
            headerName: 'Certification',
            colId: 'autorisationStatus',
            field: 'autorisationStatus',
            sortable: true,
            suppressMenu: true,
            resizable: true,
            filter: 'agTextColumnFilter',
            filterParams: {
               buttons: ['reset', 'apply'],
               filterOptions: ['contains'],
               closeOnApply: true,
               suppressAndOrCondition: true,
            }
         },

         {
            headerName: this.translate.instant('LEVEL'),
            colId: 'autorisationLevel',
            field: 'autorisationLevel',
            sortable: true,
            suppressMenu: true,
            resizable: true,
            filter: 'agTextColumnFilter',
            filterParams: {
               buttons: ['reset', 'apply'],
               filterOptions: ['contains'],
               closeOnApply: true,
               suppressAndOrCondition: true,
            }
         },
         {
            headerName: 'Action',
            colId: 'action',
            sortable: false,
            suppressMenu: true,
            resizable: true,
            maxWidth: 100,
            cellRenderer: ButtonCustomerRendererComponent,
            cellRendererParams: {
               datas: function (field: any) {
                  if (field.data) {
                     return this.field.data;
                  }
               },
               autorisation: JSON.parse(localStorage.getItem(LocalStorageKey.autorisation)),

            }
         }

      ]

      this.defaultColDef = {
         flex: 1,
         resizable: true,
         floatingFilter: true,
      };
      this.components = {
         loadingRenderer: function (params) {
            if (params.value != undefined) {
               return params.value;
            } else {
               return "<img src=\"https://raw.githubusercontent.com/ag-grid/ag-grid/master/grid-packages/ag-grid-docs/src/images/loading.gif\">";
            }
         },
      };
   }

   ngOnInit() {
      this.autorisation = JSON.parse(localStorage.getItem(LocalStorageKey.autorisation));

      this.clientRequest = {
         autorisationStatus: this.autorisation ? [this.autorisation] : [],
         offset: 0,
         pageSize: 100,
         sortColumn: '',
         sortType: '',
         fieldFilters: null,
      };
      console.log('clientRequest', this.clientRequest);
      this.setGridOptions();
   }

   setGridOptions(): void {
      this.gridOptions = {
         rowData: this.rowData,
         columnDefs: this.columnDefs,
         defaultColDef: this.defaultColDef,
         cacheBlockSize: 100,
         rowModelType: 'infinite',
         paginationPageSize: 100,
         cacheOverflowSize: 2,
         maxConcurrentDatasourceRequests: 2,
         infiniteInitialRowCount: 1,
         maxBlocksInCache: 2,
         suppressHorizontalScroll: false,
         rowSelection: 'multiple',
         icons: {
            filter: '<i class="fa fa-filter" style="font-size: 11px"></i>'
          },
         animateRows: true,
         getLocaleText: (params) => aggridLocaleFr[params.key] || params.defaultValue,
         getRowId: (params) => params.data.customerId,
         onGridReady: params => {
            this.gridApi = params.api;
            this.gridColumnApi = params.columnApi;
            const eGridDiv = document.querySelector('#gridListClient');
            if (eGridDiv.clientWidth <= 768) {
               this.gridColumnApi.autoSizeColumns(this.gridColumnApi.getColumns());
            } else {
               params.api.sizeColumnsToFit();
            }

            const dataSourceVar: IDatasource = {
               getRows: (rowParams: IGetRowsParams) => {
                  this.clientRequest.offset = rowParams.startRow;

                  this.addSortModel(rowParams.sortModel);
                  this.addFilterModel(rowParams.filterModel);
                  this.listCustomerService.getCustomers(this.clientRequest).subscribe(data => {
                     this.rowData = data.customersResponse;
                     this.gridApi.setRowCount(data.totalResults + 1);
                     rowParams.successCallback(this.rowData, data.totalResults);
                  });
               }
            };
            params.api.setDatasource(dataSourceVar);
         }
      };
   }

   onPageSizeChanged(pageSize: number): void {
      this.gridApi.paginationSetPageSize(pageSize);
      this.gridOptions.cacheBlockSize = pageSize;
      this.gridOptions.paginationPageSize = pageSize;
   }

   addFilterModel(filterModel) {
      const filterKeys = filterModel ? Object.keys(filterModel) : [];

      this.clientRequest.fieldFilters = filterKeys.map(filterKey => {
         return {
            filterType: filterModel[filterKey].type,
            filterKey,
            filter: filterModel[filterKey].filterType === 'date' ? filterModel[filterKey].dateFrom : filterModel[filterKey].filter
         };
      });
   }

   addSortModel(sortModel: SortModelItem[]) {
      const sortPresent = sortModel && sortModel.length > 0;
      if (sortPresent) {
         this.clientRequest.sortType = sortModel[0].sort;
         this.clientRequest.sortColumn = sortModel[0].colId;
      }
   }
}

@Component({
   selector: 'app-certification-client',
   templateUrl: './certification-client.component.html',
   styleUrls: ['./list-customers.component.scss']
})
export class CertificationClientComponent {
   params
   name

   constructor(
      public dialogRef: MatDialogRef<EditExternalUserComponent>,
      private clientService: ClientService,
      private toastr: ToastrService,
      @Inject(MAT_DIALOG_DATA) public data: any,
   ) {
      this.params = data.client;
      this.name = data.client.name;
   }

   back() {
      console.log("test : ", this.params)
      this.dialogRef.close();
   }

   certifier() {
      console.log("test : ", this.params)
      const clientSearch: ClientSearch = {
         siren: this.params.siren,
         siret: this.params.siret,
         crmId: this.params.crmId
      };

      this.clientService.certified(clientSearch).subscribe(
         () => {
            this.toastr.success('Le client a bien été certifié.', '', { timeOut: 7000 });
            location.reload();
         },
         () => {
            this.toastr.error('Problème lors de la certification du client.', '', { timeOut: 7000 });
         }
      )
   }
}
